"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyCartWarningModalCms = void 0;
var EmptyCartWarningModalCms = /** @class */ (function () {
    function EmptyCartWarningModalCms() {
        this.headsUpLabel = 'Heads up';
        this.modalDescLabel = "If you continue, the device and plan you previously put in your cart will be removed.";
        this.cancelCTALabel = 'Cancel';
        this.continueCTALabel = 'Continue';
        this.closeCTALabel = 'Close';
        this.errorHeadsUpLabel = 'Oops! Something went wrong.';
        this.errorDescLabel = 'Try again in a bit, or call us at 800.331.0500.';
        this.addToCartErrorLabel = "We couldn\u2019t add the new AT&T PREPAID items to your cart.\n    You\u2019ll have to select a new device and plan to continue.";
        this.shopNowCTALabel = 'Shop now';
    }
    return EmptyCartWarningModalCms;
}());
exports.EmptyCartWarningModalCms = EmptyCartWarningModalCms;
//# sourceMappingURL=EmptyCartWarningModal.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/EmptyCartWarningModal/EmptyCartWarningModal.cms.js
// module id = 955
// module chunks = 8